import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { environment } from '../../../environments/environment';

@Injectable()
export class RegisterInvitedUserService {

  headers = new HttpHeaders({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'x-functions-key': `${environment.functionKey}`
  });

  // postParam = {
  //   'key': '27bb3af6-a1cd-c915-8fec-fa53ce941b43'
  // };

  constructor(private httpClient: HttpClient) { }

  // registerInvitedUser(token) {
  //   this.httpOptions.headers = this.httpOptions.headers.set('Authorization', 'Bearer ' + token);
  //   return this.httpClient.get(`${this.apiURL}/channels/general/messages`, this.httpOptions);
  // }

  registerInvitedUser(key, postBody) {

    postBody.key = key;

    return this.httpClient.post(`${apiConfig.uriGeneral}` + '/licence/members', postBody, { headers: this.headers }); //withCredentials: true
  }

}
